import { InputAdornment } from '@mui/material';
import { EmojiPickerButton, EmojiPickerButtonProps } from './EmojiPickerButton';

/**
 * Text-field end adornment that opens an emoji picker.
 * Pass directly as TextFieldElement `InputProps.endAdornment`.
 */
export function EmojiAdornment(props: EmojiPickerButtonProps) {
  return (
    <InputAdornment position="end" sx={{ alignSelf: 'flex-start', mt: -0.5, mr: -1, ml: 0.5 }}>
      <EmojiPickerButton {...props} />
    </InputAdornment>
  );
}
